import descripcionIcon from "../../../assets/images/menu/descripcion_active.png";
import documentosIcon from "../../../assets/images/menu/documentos_active.png";
import cartografiaIcon from "../../../assets/images/menu/cartografia_historica_active.png";
import amenazaIcon from "../../../assets/images/menu/mapas_amenaza_active.png";
import lineaTiempoIcon from "../../../assets/images/menu/linea_tiempo_active.png";

export const VOLCAN_MENU_ICONS = {
  descripcion: descripcionIcon,
  timeline: lineaTiempoIcon,
  cartografia_historica: cartografiaIcon,
  mapas_amenaza: amenazaIcon,
  documentos: documentosIcon,
};
